import React from "react";
import AchievementImg from "/public/assets/img/certificates/certificate.jpg";
import ICEImg from "/public/assets/img/certificates/import-export.jpg";
import RegistrationImg from "/public/assets/img/certificates/registration.jpg";

const Section = ({
  title,
  subTitle,
  children,
  imageAlt,
  showDivider = true,
}) => {
  return (
    <>
      <h2 className="fw-bold mb-4">{title}</h2>

      <div className="row align-items-start mb-5">
        {/* Left Content */}
        <div className="col-lg-6 mb-4">
          {subTitle && <h5 className="fw-semibold mb-3">{subTitle}</h5>}
          {children}
        </div>

        {/* Right Image */}
        <div className="col-lg-6 d-flex justify-content-lg-end justify-content-center">
          <div className="border rounded p-3 shadow-sm bg-white">
            <img
              src={
                imageAlt === "Industry Outlook Award"
                  ? AchievementImg
                  : imageAlt === "IEC Certificate"
                    ? ICEImg
                    : RegistrationImg
              }
              alt={imageAlt}
              className="img-fluid"
              style={{ maxHeight: "520px" }}
            />
          </div>
        </div>
      </div>
      {/* Divider */}
      {showDivider && <hr className="my-5 opacity-25" />}
    </>
  );
};

const AwardsMemberships = () => {
  return (
    <section className="container py-5 mt-5">
      {/* ================= Awards Section ================= */}
      <Section
        title="Awards & Memberships"
        subTitle="Achievements & Recognition"
        imageAlt="Industry Outlook Award"
      >
        <h4 className="fw-semibold mb-3">Achievements</h4>

        <p className="text-muted">
          We at <strong>LubriChem Oils Pvt. Ltd.</strong> take pride in being
          recognized for our consistent efforts toward excellence in the
          lubricant industry.
        </p>

        <ul className="text-muted ps-3">
          <li className="mb-2">
            Honored by <strong>Industry Outlook</strong> as one of the
            <strong> Top 10 Industrial Lubricants & Oil Manufacturers</strong>–
            a recognition that highlights our innovation, product quality, and
            customer trust.
          </li>
          <li className="mb-2">
            This achievement reflects the vision and leadership of
            <strong> Mr. A. R. Patel</strong>, our respected Owner, whose
            dedication and strategic guidance have been instrumental in driving
            LubriChem’s growth and reputation.
          </li>
          <li>
            The award is a testament to the hard work of our entire team, our
            advanced manufacturing practices, and our unwavering focus on
            customer satisfaction.
          </li>
        </ul>

        <p className="text-muted">
          This milestone motivates us to continue raising benchmarks and moving
          closer to our goal of becoming a{" "}
          <strong>globally trusted lubricant brand.</strong>
        </p>
      </Section>

      {/* ================= Certifications Section ================= */}
      <Section
        title="Our Certifications"
        subTitle="IEC Certificate"
        imageAlt="IEC Certificate"
      >
        <p className="text-muted">
          <strong>LubriChem Oils Pvt. Ltd.</strong> is proud to hold an
          <strong> Import Export Code (IEC) Certificate</strong>, issued by the
          Directorate General of Foreign Trade (DGFT), Government of India.
        </p>

        <p className="text-muted mb-2">The IEC certification enables us to:</p>

        <ul className="text-muted ps-3">
          <li className="mb-2">
            Conduct <strong>import and export activities</strong> seamlessly
            across global markets.
          </li>
          <li className="mb-2">
            Expand our presence by supplying high-quality lubricants and
            specialty oils worldwide.
          </li>
          <li className="mb-2">
            Strengthen international trade relationships and explore new
            business opportunities.
          </li>
          <li>
            Ensure compliance with Indian government regulations for global
            trade.
          </li>
        </ul>

        <p className="text-muted mt-3">
          With the IEC Certificate, LubriChem is well-positioned to achieve its
          vision of becoming a <strong>globally recognized brand</strong>,
          delivering excellence beyond borders.
        </p>
      </Section>

      {/* ================= ISO Certification Section ================= */}
      <Section
        title="Certificate of Registration"
        subTitle="Certificate of Registration – ISO 9001:2015"
        imageAlt="ISO 9001:2015 Certificate"
        showDivider={false}
      >
        <p className="text-muted">
          <strong>LubriChem Oils Pvt. Ltd.</strong> is officially registered and
          certified under{" "}
          <strong>ISO 9001:2015 Quality Management System</strong>.
        </p>

        <p className="text-muted mb-2">
          This <strong>Certificate of Registration</strong> demonstrates our
          commitment to:
        </p>

        <ul className="text-muted ps-3">
          <li className="mb-2">
            Maintaining internationally recognized standards in
            <strong> manufacturing and operations</strong>.
          </li>
          <li className="mb-2">
            Delivering products that consistently meet
            <strong> customer expectations and regulatory requirements</strong>.
          </li>
          <li className="mb-2">
            Driving a culture of <strong>continuous improvement</strong>,
            efficiency, and customer satisfaction.
          </li>
          <li>
            Ensuring strong <strong>process control and documentation</strong>
            practices at every stage of production.
          </li>
        </ul>

        <p className="text-muted mt-3">
          Our ISO 9001:2015 registration reflects not just compliance, but our
          dedication to <strong>excellence and quality</strong> in everything we
          do.
        </p>
      </Section>
    </section>
  );
};

export default AwardsMemberships;
